import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  info: {},
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/info/index.js